export default "__VITE_ASSET__DgkhoV6w__"